export let expandToSurrogatePairs = function expandToSurrogatePairs(blockRange, text) {
  text = text || '';
  let startIndex = blockRange.get('startPoint.positionIndex');
  let endIndex = blockRange.get('endPoint.positionIndex');
  let startCode = text.charCodeAt(startIndex);
  let endCode = text.charCodeAt(endIndex - 1);
  if (_isLowSurrogate(startCode)) {
    blockRange.set('startPoint.positionIndex', --startIndex);
  }
  if (_isHighSurrogate(endCode)) {
    blockRange.set('endPoint.positionIndex', ++endIndex);
  }
};
function _isLowSurrogate(code) {
  return 0xdc00 <= code && code <= 0xdfff;
}
function _isHighSurrogate(code) {
  return 0xd800 <= code && code <= 0xdbff;
}